import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { submitRateUsers } from "../Api";

function RatePlayerModal({
    match_id,
    user_id,
    profile_image,
    full_name,
    onClose,
    onSubmit, // optional callback
}) {
    const [rating, setRating] = useState(0);
    const [hover, setHover] = useState(0);
    const [isVisible, setIsVisible] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    const handleClose = () => {
        setIsVisible(false);
        setTimeout(onClose, 300);
    };

    const handleSubmit = async () => {
        if (rating === 0) {
            alert("Please select a rating.");
            return;
        }
        setLoading(true);
        try {
            await submitRateUsers(match_id, user_id, rating);
            if (onSubmit) onSubmit(match_id, user_id, rating);
            handleClose();
        } catch (error) {
            alert("Failed to submit rating. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            onClick={handleClose}
            style={{
                position: "fixed",
                inset: 0,
                backgroundColor: isVisible ? "rgba(0,0,0,0.5)" : "rgba(0,0,0,0)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1050,
                transition: "background-color 300ms ease",
            }}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                style={{
                    transform: isVisible ? "scale(1)" : "scale(0.8)",
                    opacity: isVisible ? 1 : 0,
                    transition: "opacity 300ms ease, transform 300ms ease",
                    willChange: "transform, opacity",
                }}
            >
                <Modal
                    show
                    onHide={handleClose}
                    centered
                    backdrop={false}
                    keyboard={false}
                    dialogClassName="small-modal"
                >
                    <Modal.Header closeButton style={{ padding: "0.75rem 1rem" }}>
                        <Modal.Title style={{ fontSize: "1.5rem", fontWeight: "600" }}>
                            Rate Player
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="text-center" style={{ padding: "1rem 1.25rem" }}>
                        <img
                            src={profile_image || "/default-avatar.png"}
                            alt={full_name}
                            className="rounded-circle mb-3"
                            style={{
                                width: 80,
                                height: 80,
                                objectFit: "cover",
                                border: "3px solid #dee2e6",
                            }}
                        />
                        <h5 className="mb-4" style={{ fontSize: "1.4rem", fontWeight: "600" }}>
                            {full_name}
                        </h5>

                        <div className="mb-2">
                            {[1, 2, 3, 4, 5].map((star) => (
                                <span
                                    key={star}
                                    style={{
                                        fontSize: "3.5rem",
                                        cursor: "pointer",
                                        color: (hover || rating) >= star ? "#f0ad4e" : "#ccc",
                                        transition: "transform 0.15s ease",
                                    }}
                                    onClick={() => setRating(star)}
                                    onMouseEnter={() => setHover(star)}
                                    onMouseLeave={() => setHover(0)}
                                >
                                    ★
                                </span>
                            ))}
                        </div>
                    </Modal.Body>
                    <Modal.Footer style={{ padding: "0.5rem 1rem" }}>
                        <Button variant="secondary" size="sm" onClick={handleClose} disabled={loading}>
                            Cancel
                        </Button>
                        <Button variant="primary" size="sm" onClick={handleSubmit} disabled={loading}>
                            {loading ? "Submitting..." : "Submit Rating"}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>

            <style jsx>{`
        .small-modal .modal-dialog {
          max-width: 300px;
          margin: 1.75rem auto;
        }
      `}</style>
        </div>
    );
}

export default RatePlayerModal;
